import md5 from 'js-md5'
import CryptoJs from 'crypto-js'

const TokenKey = 'token'
export function randomToken(len) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var token = '';
  for (let i = 0; i < len; i++) {
    token += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return token;
}
export function getToken() {
  const token = localStorage.getItem(TokenKey) && localStorage.getItem(TokenKey) != 'undefined' ? localStorage.getItem(TokenKey): '';
  return token
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token,{ expires: 7})
}

export function getBaseURL() {
  return process.env.VUE_APP_BASE_API
}
export function getBaseURLs() {
  return process.env.VUE_APP_APIS
}
export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function nowTime() {
  return Date.parse(new Date()).toString().substr(0, 10)
}
export function nowTimes() {
  return Date.parse(new Date()).toString().substr(0, 10)
}
export function getSign(data) {
  const arrKey = Object.keys(data).sort()
  let str = ''
  arrKey.forEach(i => {
    data[i] = (data[i] == null ? '' : data[i])
    str += i + '=' + data[i]
  })
  str += 'e1def8a46b7c673d5a4a111920f24e8c'
  return md5(str)
}

export function decrypt(str)  {
  const key = CryptoJs.enc.Latin1.parse('bb05d576fedbf041206fce9ce065aa2a');
  const iv = CryptoJs.enc.Latin1.parse('bb2ee32314651d2a')
  const encryptedHexStr = CryptoJs.enc.Base64.parse(str)
  const srcs = CryptoJs.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJs.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJs.mode.CBC, padding: CryptoJs.pad.Pkcs7 })
  const decryptedStr = decrypt.toString(CryptoJs.enc.Utf8)
  return decryptedStr.toString()
};

export function getQuery() {
  var url = window.location.search; //获取url中"?"符后的字串
  let theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    if(str.indexOf("&") != -1) {
      let strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      }
    } else {
      let arr = str.split("=");
      theRequest[arr[0]] = arr[1];
    }
  };
  return theRequest;
}

export function getAesCode(word){
  var api_param = {
        client_id: '74450c23fa139888c2240568a276879d',
        client_secret: '1135d1764574fb0f1c557a6fde5fb942',
        aes_key: '5AC6C1F5EA233A41DC5E0DC450CC7B61',
        aes_iv: 'AD243DD5CB69BC29'
      }
    // var api_param = JSON.parse(uni.getStorageSync('api_param'))
    const srcs =  JSON.stringify(word)
    const key = CryptoJs.enc.Utf8.parse(api_param.aes_key)
    const encrypted = CryptoJs.AES.encrypt( srcs, key, { iv: CryptoJs.enc.Utf8.parse(api_param.aes_iv), mode: CryptoJs.mode.CBC, padding: CryptoJs.pad.Pkcs7})
    return encrypted.toString()
};

export function getApiSign(arr){
  var api_param = {
        client_id: '74450c23fa139888c2240568a276879d',
        client_secret: '1135d1764574fb0f1c557a6fde5fb942',
        aes_key: '5AC6C1F5EA233A41DC5E0DC450CC7B61',
        aes_iv: 'AD243DD5CB69BC29'
      }
      var arr_key = Object.keys(arr).sort()
      var str = ''
      for(var i in arr_key){
        if(arr_key[i] !== 'sign'){
          str += arr_key[i] + '=' + arr[arr_key[i]]
        }
      }
      str += api_param.client_secret
      return md5(str)
}